(function () {
  var syncing = false;
  var timers = [];

  function clearTimers() {
    while (timers.length) clearTimeout(timers.pop());
  }

  function sync() {
    if (syncing) return;
    syncing = true;
    try {
      var modal = document.getElementById('modalAddToCartProduct');
      if (!modal) return;
      var popup = modal.querySelector('.iron-atc-popup');
      var desk = modal.querySelector('.tt-modal-addtocart.desctope');
      if (!popup || !desk) return;

      var dTitle = desk.querySelector('.tt-title-js');
      var dVar = desk.querySelector('.description');
      var dQty = desk.querySelector('.tt-qty span');
      var dPrice = desk.querySelector('.total-product-js .tt-price');
      var dImg = desk.querySelector('.tt-img img');

      var mTitle = popup.querySelector('.iron-atc-popup__title');
      var mVar = popup.querySelector('.iron-atc-popup__variant');
      var mQty = popup.querySelector('.iron-atc-popup__qty');
      var mPrice = popup.querySelector('.iron-atc-popup__price');
      var mImg = popup.querySelector('.iron-atc-popup__img');

      if (mTitle && dTitle) mTitle.textContent = (dTitle.textContent || '').trim();

      if (mVar) {
        var vt = dVar ? (dVar.textContent || '').trim() : '';
        var visible = dVar && dVar.style.display !== 'none' && vt;
        mVar.textContent = visible ? vt : '';
        mVar.style.display = visible ? '' : 'none';
      }

      if (mQty) {
        var q = dQty ? (dQty.textContent || '').trim() : '';
        mQty.textContent = q ? (q + ' X') : '';
      }

      if (mPrice) mPrice.innerHTML = dPrice ? dPrice.innerHTML : '';

      if (mImg && dImg && dImg.getAttribute('src')) {
        var src = dImg.getAttribute('src');
        var existing = mImg.querySelector('img');
        if (!existing) {
          existing = document.createElement('img');
          existing.alt = dImg.getAttribute('alt') || '';
          mImg.appendChild(existing);
        }
        if (existing.getAttribute('src') !== src) existing.setAttribute('src', src);
      }
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    clearTimers();
    sync();
    timers.push(setTimeout(sync, 30));
    timers.push(setTimeout(sync, 120));
    timers.push(setTimeout(sync, 350));
  }

  function bind() {
    var modal = document.getElementById('modalAddToCartProduct');
    if (!modal || modal.getAttribute('data-iron-atc') === '1') return;
    modal.setAttribute('data-iron-atc', '1');
    // jQuery/Bootstrap events
    if (window.jQuery) {
      window.jQuery(modal).on('show.bs.modal.ironAtc shown.bs.modal.ironAtc', scheduleSync);
    }
    modal.addEventListener('show.bs.modal', scheduleSync);
    modal.addEventListener('shown.bs.modal', scheduleSync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
